import { MouseEventHandler, forwardRef, PropsWithChildren, useCallback } from 'react';
import classNames from 'classnames';
import { useRipple } from '@bg-shared';

export interface IRippleButtonProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    rippleDisabled?: boolean;
    dataQa?: string;
    'aria-label'?: string;
    disabled?: boolean;
    submitButton?: boolean;
    optionItemID?: string;
    ariaExpanded?: boolean;
    ariaControls?: string;
}

export const RippleButton = forwardRef<HTMLButtonElement, PropsWithChildren<IRippleButtonProps>>(
    ({ rippleDisabled = false, ...props }, ref) => {
        const ripple = useRipple();
        const onMouseDown = useCallback(() => {
            if (!rippleDisabled) {
                ripple.start();
            }
        }, [rippleDisabled]);

        return (
            <button
                type={props.submitButton ? 'submit' : 'button'}
                ref={ref}
                className={classNames(props.className, {
                    [ripple.className]: !rippleDisabled,
                })}
                onClick={props.onClick}
                onMouseDown={onMouseDown}
                data-qa={props.dataQa}
                aria-label={props['aria-label']}
                aria-expanded={props.ariaExpanded}
                aria-controls={props.ariaControls}
                disabled={props.disabled}
                data-option-item-id={props.optionItemID ? props.optionItemID : undefined}
            >
                {props.children}
            </button>
        );
    },
);
